/*eslint-disable*/ module.exports = {
  messages: {
    Active: 'Active',
    Add: 'Add',
    'Add Beer Selection': 'Add Beer Selection',
    'Add Beer Servings': 'Add Beer Servings',
    'Add New dish': 'Add New dish',
    'Add New item': 'Add New item',
    'Add Picture': 'Add Picture',
    'Add QR code': 'Add QR code',
    'Add Star Of The Crafters': 'Add The Brewers Star - BW',
    'Add Colored Star Of The Crafters': 'Add The Brewers Star - color',
    'Add category or element': 'Add category or element',
    'Add dish': 'Add dish',
    'Add meal': 'Add meal',
    'Add new menu': 'Add new menu',
    'Add other': 'Add other',
    'Add soup': 'Add soup',
    'After creating a category, you can add dishes.':
      'After creating a category, you can add dishes.',
    'Alcohol Content': 'Alcohol Content',
    All: 'All',
    'All languages': 'All languages',
    Allergens: 'Allergens',
    Amount: 'Amount',
    'Are you sure you want to delete this daily menu?':
      'Are you sure you want to delete this daily menu?',
    'Are you sure you want to delete this menu?':
      'Are you sure you want to delete this menu?',
    'Available only for A4 size': 'Available only for A4 size',
    'Back to Daily Menu': 'Back',
    'Back to Food Menu': 'Back',
    'Beer Selection': 'Beer Selection',
    'Beer Type': 'Beer Type',
    'Beer servings': 'Beer servings',
    Bottom: 'Bottom',
    'Brand elements': 'Brand elements',
    "Can't upload image": "Can't upload image",
    Cancel: 'Cancel',
    Categories: 'Categories',
    'Click to select a date': 'Click to select a date',
    Close: 'Close',
    Color: 'Color',
    Continue: 'Continue',
    'Copy menu': 'Copy menu',
    'Country Of Origin': 'Country Of Origin',
    'Create Text Block': 'Create Text Block',
    Currency: 'Currency',
    'Daily Menu': 'Daily Menu',
    'Daily menu': 'Daily menu',
    Data: 'Data',
    'Data & Elements': 'Data & Elements',
    Delete: 'Delete',
    'Delete menu': 'Delete menu',
    'Delete page break': 'Delete page break',
    Description: 'Description',
    'Description (Optional)': 'Description (Optional)',
    Desserts: 'Desserts',
    Designs: 'Designs',
    Displays: 'Displays',
    'Double Image Block': 'Double Image Block',
    Duplicate: 'Duplicate',
    'Duplicate menu': 'Duplicate menu',
    Edit: 'Edit',
    'Edit Beer Servings': 'Edit Beer Servings',
    'Edit Picture': 'Edit Picture',
    'Edit QR code': 'Edit QR code',
    'Edit Star Of The Crafters': 'Edit The Brewers Star - BW',
    'Edit Colored Star Of The Crafters': 'Edit The Brewers Star - color',
    'Edit Text Block': 'Edit Text Block',
    'Edit dish': 'Edit dish',
    Elements: 'Elements',
    Email: 'Email',
    'Error!': 'Error!',
    Export: 'Export',
    'Export XML': 'Export XML',
    'Export PDF': 'Export as PDF',
    'Export as JPG': 'Export as JPG',
    Fermentation: 'Fermentation',
    'Fill in your contact information and we will reach back to you:':
      'Fill in your contact information and we will reach back to you:',
    'Food Combinations': 'Food Combinations',
    'Food cards & Specials': 'Food cards & Specials',
    'Food image': 'Food image',
    'Generate QR code': 'Generate QR code',
    Grid: 'Grid',
    'Hover over the tab area to see options for adding categories and elements.':
      'Hover over the tab area to see options for adding categories and elements.',
    'Hviezda sladkov': 'The Brewers Star - BW',
    'Farebna hviezda sladkov': 'The Brewers Star - color',
    Inline: 'Inline',
    'Jsme hrdí držitelé hvězdy sládku 2020':
      'Jsme hrdí držitelé hvězdy sládku 2020',
    Language: 'Language',
    List: 'List',
    'Log in': 'Log in',
    Logo: 'Logo',
    'Logo (Not available)': 'Logo (Not available)',
    Logout: 'Logout',
    Meals: 'Meals',
    Menu: 'Menu',
    'Move Block': 'Move Block',
    'Move Dish': 'Move Dish',
    'Move Dish position': 'Move Dish position',
    'Move after block': 'Move after block',
    'Move after dish': 'Move after dish',
    'Move block position': 'Move block position',
    'Move to beginning': 'Move to beginning',
    Name: 'Name',
    'Name of Restaurant': 'Name of Restaurant',
    'Name of category': 'Name of category',
    Next: 'Next',
    'No daily menus were found. Please try to change filters.':
      'No daily menus were found. Please try to change filters.',
    'No menus were found. Please try to change filters.':
      'No menus were found. Please try to change filters.',
    'Ocenění za nejlepší peči o čepované pivo':
      'Ocenění za nejlepší peči o čepované pivo',
    'One column': 'One column',
    'One column with image': 'One column with image',
    'Order Print': 'Order Print',
    Other: 'Other',
    Others: 'Others',
    'Page break': 'Page break',
    Phone: 'Phone',
    Picture: 'Picture',
    'Please continue by logging in': 'Please continue by logging in',
    Position: 'Position',
    Preview: 'Preview',
    Price: 'Price',
    'Price with soup': 'Price with soup',
    'Price with meal': 'Price with meal',
    'Price with soup and meal': 'Price with soup and meal',
    Primary: 'Primary',
    'Secondary Primary': 'Primary',
    Print: 'Print',
    'QR code': 'QR code',
    'Recommend a drink': 'Recommend a drink',
    Remove: 'Remove',
    'Remove category': 'Remove category',
    'Remove dish': 'Remove dish',
    'Required field': 'Required field',
    Save: 'Save',
    'Select allergens': 'Select allergens',
    'Serving Temperature': 'Serving Temperature',
    'Set to active': 'Set to active',
    'Set to inactive': 'Set to inactive',
    Settings: 'Settings',
    Share: 'Share',
    'Share on FB': 'Share on FB',
    'Copy menu link': 'Copy menu link',
    'Show Allergens': 'Show Allergens',
    'Show Title Page': 'Show Title Page',
    'Show info': 'Show info',
    'Show name of Restaurant': 'Show name of Restaurant',
    'Show portion size': 'Show portion size',
    'Show text': 'Show text',
    'Show weight / bulk / pieces': 'Show weight / bulk / pieces',
    Size: 'Size',
    'Secondary Size': 'Size',
    'size in cl': 'size in cl',
    'size in ml': 'size in ml',
    Soup: 'Soup',
    'Soup can be orderer separately': 'Soup can be orderer separately',
    'Soup priced in main dish': 'Soup priced in main dish',
    Soups: 'Soups',
    Submit: 'Submit',
    Taste: 'Taste',
    Templates: 'Templates',
    'Text block': 'Text block',
    'Tips & Tricks': 'Tips & Tricks',
    Title: 'Title',
    'Two columns': 'Two columns',
    'Two columns with image': 'Two columns with image',
    'Type or choose category': 'Type or choose category',
    'Type or choose dish': 'Type or choose dish',
    'URL address': 'URL address',
    Untitled: 'Untitled',
    'Upload image': 'Upload image',
    'We do not offer anything for this day':
      'We do not offer anything for this day',
    'We do not offer:': 'We do not offer:',
    'Weight / bulk / pcs': 'Weight / bulk / pcs',
    'Weight / bulk / pieces': 'Weight / bulk / pieces',
    'You might loose some layout settings by this change. Do you wish to continue?':
      'You might loose some layout settings by this change. Do you wish to continue?',
    'Známky kvalitně načepovaného piva': 'Známky kvalitně načepovaného piva',
    add: 'add',
    'category/element': 'category/element',
    description: 'description',
    item: 'item',
    language: 'language',
    languange: 'languange',
    logo: 'logo',
    'remove page': 'remove page',
    units: 'units',
    '{0}': [['0']],
    '{label}': [['label']],
    'Secondary Menu': 'Menu',
    'Secondary Other': 'Other',
    'Logo (Not available)': 'Logo (Not available)',
    "Can't upload image": "Can't upload image",
    'Description not available': 'Description not available',
    'Edit Beer Selection': 'Edit Beer Selection',
    'Title is required': 'Title is required',
    'Select beers': 'Select beers',
    'Mandatory field': 'Mandatory field',
    Image: 'Image',
    'not available': 'not available',
    'Copied successfully!': 'Copied successfully!',
    'Error copied!': 'Error copied!',
    'Separate price for each item': 'Separate price for each item',
    'Soup price is included in menu': 'Soup price is included in menu',
    'Different price for whole menu': 'Different price for whole menu',
    'Responsibility Message': 'Responsibility Message',
    'ID:': 'ID',
    'Please complete the first 2 steps': 'Please complete the first 2 steps',
    'Image generation in progress. Please wait. When the download is complete, return to the list of daily menus.':
      'Image generation in progress. Please wait. When the download is complete, return to the list of daily menus.',
    'Are you sure you want to delete this category?':
      'Are you sure you want to delete this category?',
    Yes: 'Yes',
    No: 'No',
    'Delete item': 'Delete item',
    'Edit element': 'Edit element',
    'Write a name': 'Write a name',
    'Create category': 'Create category',
    'Edit category': 'Edit category',
    'Delete category': 'Delete category',
    'Choose a category': 'Choose a category',
    Custom: 'Custom',
    'Add item': 'Add item',
    'Add category': 'Add category',
    'This category already exists.': 'This category already exists.',
    'Something went wrong, probably your file exceeds the allowed post-processing size 10Mb. Please try again with a smaller file.':
      'Something went wrong, probably your file exceeds the allowed post-processing size 10Mb. Please try again with a smaller file.',
    'The uploaded file exceeds the maximum allowed size of 10MB. Please upload a smaller file.':
      'The uploaded file exceeds the maximum allowed size of 10MB. Please upload a smaller file.',
    Warning: 'Warning',
    'You might loose some layout settings by this change. Do you wish to continue?':
      'You might loose some layout settings by this change. Do you wish to continue?',
    'Bottom description': 'Bottom description',
    'Logo size': 'Logo size',
    Small: 'Small',
    Medium: 'Medium',
    Large: 'Large',

    Warning: 'Warning',
    'Before sending the menu to the printer, please carefully check the content and graphics of the menu in the PDF preview! The printing company is not responsible for the content of the data sent in the order.':
      'Before sending the menu to the printer, please carefully check the content and graphics of the menu in the PDF preview! The printing company is not responsible for the content of the data sent in the order.',
    'Print Parameters': 'Print Parameters',
    Name: 'Name',
    'Number of Menu Pages': 'Number of Menu Pages',
    'Menu Format': 'Menu Format',
    'Paper Color': 'Paper Color',
    'Type of Binding': 'Type of Binding',
    'Paper Finish': 'Paper Finish',
    'Number of Copies': 'Number of Copies',
    'Price Excluding VAT:': 'Price Excluding VAT:',
    'Shipping Excluding VAT:': 'Shipping Excluding VAT:',
    'Total Including VAT:': 'Total Including VAT:',
    'The name, number of pages, and format can only be modified in the editor menu.':
      'The name, number of pages, and format can only be modified in the editor menu.',
    'Menu without binding or with Twin binding are always made double-sided, Wire Stitched binding uses the entire four sides...':
      'Menu without binding or with Twin binding are always produced double-sided, while Wire Stitched binding uses the entire four sides. If your menu does not have a number of pages divisible by four, it is not possible to choose the Wire Stitched binding. For menus up to 4 pages, it is also not possible to select any binding, and the menu will always be produced without binding.',
    'Billing Address': 'Billing Address',
    'First and Last Name': 'First and Last Name',
    'Street/No.': 'Street/No.',
    City: 'City',
    'Postal Code': 'Postal Code',
    Country: 'Country',
    'Company ID': 'Company ID',
    Phone: 'Phone',
    'E-mail': 'E-mail',
    'Different Shipping Address': 'Different Shipping Address',
    'Order Summary': 'Order Summary',
    'Discount Code': 'Discount Code',
    'Terms and Conditions': 'Terms and Conditions',
    'The customer acknowledges that the company is not responsible for the content of data provided within the order.':
      'The customer acknowledges that the company is not responsible for the content of data provided within the order.',
    'The customer agrees that the order will be sent on delivery.':
      'The customer agrees that the order will be sent on delivery.',
    'The customer confirms the order of services and agrees that their production should be started immediately.':
      'The customer confirms the order of services and agrees that their production should be started immediately.',
    'I agree with the terms and conditions':
      'I agree with the terms and conditions',
    Price: 'Price',
    'Submit Order': 'Submit Order',
    'We have received your order!': 'We have received your order!',
    'Required field': 'Required field',
    'We have received your order and processing it. Confirmation of your order has been sent to the email provided in the order.':
      'We have received your order and processing it. Confirmation of your order has been sent to the email provided in the order.',
    'Back to Editor': 'Zpět na editor',
    'Note for the printer': 'Note for the printer',
    'Submission failed!': 'Odeslání se nepodařilo!',
    'Without (2 pages)': 'Without (2 pages)',
    'Fold (4 pages)': 'Fold (4 pages)',
    Ring: 'Ring',
    'Wire Stitched': 'Wire Stitched',
    'Without Print Finish': 'Without',
    'Matte Print Finish': 'Matte',
    'Shiny Print Finish': 'Shiny',
    'White 250g': 'White 250g',
    'Cream 250g': 'Cream 250g',
  },
}
